var map = {
	"./bet-logo-9lotto.png": 627,
	"./bet-logo-big-cash.png": 628,
	"./bet-logo-damacai-inversed.png": 629,
	"./bet-logo-damacai.png": 630,
	"./bet-logo-gd.png": 631,
	"./bet-logo-gdlotto.png": 632,
	"./bet-logo-harihari.png": 633,
	"./bet-logo-magnum.png": 634,
	"./bet-logo-p8.png": 635,
	"./bet-logo-perdana.png": 636,
	"./bet-logo-sabah88.png": 637,
	"./bet-logo-singapore-pools.png": 638,
	"./bet-logo-stc.png": 639,
	"./bet-logo-toto-inversed.png": 640,
	"./bet-logo-toto.png": 641,
	"./gdlotto.png": 642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;